module.exports = __webpack_public_path__ + "static/media/settings.56bd52b7.png";